import { render, staticRenderFns } from "./composer.vue.js?vue&type=template&id=9c8ee194!=!../../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./composer.vue?vue&type=template&id=9c8ee194"
import script from "./composer.vue.js?vue&type=script&lang=js!=!../../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./composer.vue?vue&type=script&lang=js"
export * from "./composer.vue.js?vue&type=script&lang=js!=!../../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./composer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports